// Rozmowa z asystentem — strona główna aplikacji.
export default {
    title: 'Asystent',
    today: 'Dziś',
    yesterday: 'Wczoraj',
    previousDay: 'Poprzedni dzień z rozmową',
    nextDay: 'Następny dzień z rozmową',
    backToToday: 'Wróć do dziś',
    emptyDay: 'Tego dnia nic nie zostało powiedziane.',
    loadFailed: 'Nie udało się wczytać rozmowy.',
    retry: 'Spróbuj ponownie',
    composer: {
        placeholder: 'Napisz, co robisz, jesz, wydajesz albo planujesz…',
        send: 'Wyślij',
        speak: 'Powiedz',
        stop: 'Zakończ i wyślij',
        cancel: 'Anuluj nagranie',
        receipt: 'Dodaj zdjęcia',
        addPhoto: 'Dodaj kolejne zdjęcie',
        removePhoto: 'Usuń zdjęcie',
        photoHint: 'Dopisz, co z nim zrobić — albo wyślij samo. | Dopisz, co z nimi zrobić — albo wyślij same. | Dopisz, co z nimi zrobić — albo wyślij same.',
        photoLimit: 'Najwyżej {n} zdjęć w jednej wiadomości — dodałem pierwsze {n}.',
        readingPhotos: 'Czytam {n} zdjęcie… | Czytam {n} zdjęcia — to może potrwać około minuty… | Czytam {n} zdjęć — to może potrwać około minuty…',
        listening: 'Słucham…',
        transcribing: 'Rozpoznaję…',
        thinking: 'Asystent zapisuje…',
        // gdy asystent ma własne imię
        thinkingNamed: '{name} zapisuje…',
        // podpis zdjęcia w wiadomości — po tym, czym okazało się dla asystenta
        photoSent: {
            expense: 'Zdjęcie paragonu',
            meal: 'Zdjęcie posiłku',
            shopping: 'Zdjęcie listy zakupów',
            task: 'Zdjęcie listy zadań',
            project: 'Zdjęcie listy do projektu',
            event: 'Zdjęcie wydarzenia',
            note: 'Zdjęcie notatki',
            unknown: 'Zdjęcie',
        },
        photosSent: '{n} zdjęcie | {n} zdjęcia | {n} zdjęć',
    },
    goingOn: {
        title: 'Trwa',
        finish: 'Zakończ',
        finishText: 'Koniec: {name}',
    },
    rightNow: {
        title: 'Teraz',
        more: '+{n} więcej',
        done: 'Zrobione',
        now: 'teraz',
        in: 'za {time}',
        at: 'o {time}',
        late: 'spóźnione {time}',
        going: 'trwa · do {time}',
        today: 'dziś',
        payLate: 'po terminie',
        projectToday: 'termin dziś',
        projectTomorrow: 'termin jutro',
        overdue: '{n} zaległe zadanie | {n} zaległe zadania | {n} zaległych zadań',
        minutes: '{m} min',
        hours: '{h} h',
        hoursMinutes: '{h} h {m} min',
        personDate: '{what}: {name}',
        inDays: 'za {n} dzień | za {n} dni | za {n} dni',
        gifts: '{n} pomysł na prezent | {n} pomysły na prezent | {n} pomysłów na prezent',
        lastContact: 'ostatnio {when}',
        noContact: 'jeszcze bez kontaktu',
        care: '{subject}: {name}',
        careDone: 'Zrobione',
        warranty: 'Koniec gwarancji: {name}',
        petBirthday: 'Urodziny: {name}',
        petAge: 'kończy {n} rok | kończy {n} lata | kończy {n} lat',
        habits: 'Nawyki na dziś: {done} z {total}',
        medicationTaken: 'Wzięte',
        medicationStock: 'Kończy się: {name}',
        medicationDaysLeft: 'na {n} dzień | na {n} dni',
    },
    questions: {
        title: 'Do uzupełnienia',
        answer: 'Odpowiedz',
        dismiss: 'Pomiń pytanie',
    },
    message: {
        failed: 'Nie udało się wysłać.',
        aiUnavailable: 'Asystent jest chwilowo niedostępny.',
        aiLimit: 'Limit AI wyczerpany — wiadomość nie poszła.',
        retry: 'Wyślij ponownie',
        discard: 'Usuń',
        delete: 'Usuń wiadomość',
        play: 'Przeczytaj na głos',
        spoken: 'Powiedziane',
    },
    record: {
        undo: 'Cofnij',
        undone: 'cofnięte',
        missing: 'usunięte',
        deleted: 'usunięto',
        open: 'Zobacz',
        undoFailed: 'Nie udało się cofnąć.',
    },
    remove: {
        title: 'Usunąć wiadomość?',
        withRecords: 'Usuń też to, co z niej zapisano',
        confirm: 'Usuń',
        cancel: 'Anuluj',
        failed: 'Nie udało się usunąć wiadomości.',
    },
    summary: {
        open: 'Podsumuj dzień',
        disabledHint: 'Tego dnia nie ma jeszcze wiadomości — napisz albo powiedz asystentowi, co robisz, a będzie co podsumować.',
        title: 'Wpis dnia',
        intro: 'Asystent zebrał dzień w kilku zdaniach. Popraw, co chcesz, i zapisz.',
        loading: 'Asystent pisze podsumowanie…',
        empty: 'Ten dzień nie ma jeszcze rozmowy do podsumowania.',
        save: 'Zapisz wpis dnia',
        cancel: 'Anuluj',
        saved: 'Wpis dnia zapisany.',
        failed: 'Nie udało się przygotować podsumowania.',
        saveFailed: 'Nie udało się zapisać wpisu dnia.',
    },
    // Ściąga: co asystent umie zapisać, po modułach, z przykładami (klik wkleja do pola)
    sheet: {
        open: 'Ściąga',
        openHint: 'Co możesz mówić i dokąd to trafia',
        title: 'Ściąga',
        intro: 'Mów albo pisz zwyczajnie, jak do kogoś bliskiego — kilka rzeczy naraz też. Kliknij przykład, żeby wkleić go do pola.',
        notEnabled: 'włączy się przy pierwszym zapisie',
        suggestionsTitle: 'Na przykład',
        groups: {
            wallet: {
                title: 'Wydatki i wpływy',
                where: 'Portfel — transakcja z kategorią. Potem możesz dosłać zdjęcie paragonu aparatem obok pola: rozbije wydatek na produkty.',
                ex1: 'Wydałem 100 zł w Biedronce',
                ex2: 'Zapłaciłem 45 zł za taksówkę',
                ex3: 'Dostałem 300 zł zwrotu od Kasi',
            },
            food2: {
                title: 'Jedzenie',
                where: 'Jedzenie — posiłek z kaloriami i makro, zjedzony albo zaplanowany.',
                ex1: 'Zjadłem owsiankę z bananem',
                ex2: 'Na obiad była zupa pomidorowa i dwa pierogi',
                ex3: 'Na kolację planuję makaron z pesto',
            },
            basket: {
                title: 'Zakupy do zrobienia',
                where: 'Koszyk — pozycje na liście zakupów.',
                ex1: 'Kup mleko, jajka i chleb',
                ex2: 'Skończyła się pasta do zębów',
            },
            forma: {
                title: 'Ruch i sen',
                where: 'Forma — trening albo noc snu.',
                ex1: 'Biegałem 30 minut',
                ex2: 'Idę spać',
                ex3: 'Wstałem o 7',
            },
            plans: {
                title: 'Plany',
                where: 'Planer — wydarzenie, gdy podasz godzinę; zadanie, gdy nie (bez dnia trafia do „Do rozplanowania").',
                ex1: 'Jutro o 18 dentysta',
                ex2: 'W piątek muszę zadzwonić do mamy',
                ex3: 'Kiedyś trzeba wymienić opony',
            },
            activities: {
                title: 'Czynności',
                where: 'Planer — czynność z początkiem i końcem. Asystent liczy czas; trwające widać nad polem z przyciskiem „Zakończ".',
                ex1: 'Idę pod prysznic',
                ex2: 'Skończyłem',
                ex3: 'Od 14 do 15 sprzątałem mieszkanie',
            },
            notes: {
                title: 'Notatki i myśli',
                where: 'Notatnik — gdy prosisz o zapisanie; powiedz kategorię, a notatka do niej trafi. Zwykła myśl czy opowieść o dniu zostaje w rozmowie i trafia do podsumowania dnia.',
                ex1: 'Zanotuj: pomysł na prezent dla Ani — książka o górach',
                ex2: 'Zanotuj w książkach: Solaris',
                ex3: 'Dziś było naprawdę spokojnie',
            },
            projects: {
                title: 'Projekty',
                where: 'Projekty — zadania w projekcie o tej nazwie, a gdy powiesz sekcję, to w niej. Gdy takiego projektu nie ma, asystent zapyta, do którego.',
                ex1: 'Dodaj do remontu: farba, wałki, taśma',
                ex2: 'Do remontu, w kuchni: wymienić baterię',
            },
            people: {
                title: 'Ludzie',
                where: 'Ludzie — urodziny i inne ważne daty, pomysły na prezent i rozmowy przy osobie, którą rozpoznam po imieniu albo „mama", „szef". Nowa osoba dopisze się sama.',
                ex1: 'Kasia ma urodziny 14 marca',
                ex2: 'Pomysł na prezent dla mamy: nowa patelnia',
                ex3: 'Rozmawiałem dziś z tatą o wakacjach',
            },
            pets: {
                title: 'Zwierzęta',
                where: 'Zwierzęta — szczepienia, odrobaczanie i inne obsługi (zrobione przesuwają następny termin) oraz waga. Nowe zwierzę dopisze się samo.',
                ex1: 'Zaszczepiłem dziś Burka na wściekliznę, 120 zł',
                ex2: 'Burek waży 12,4 kg',
                ex3: 'Kiedy Burek ma odrobaczanie?',
            },
            devices: {
                title: 'Sprzęty',
                where: 'Sprzęty — przeglądy, serwisy i wymiany z kosztem (zrobione przesuwają następny termin) oraz gwarancja. Nowy sprzęt dopisze się sam.',
                ex1: 'Wymieniłem filtr w oczyszczaczu',
                ex2: 'Byłem z autem na przeglądzie, 150 zł',
                ex3: 'Gwarancja na pralkę do 12 maja 2028',
            },
            habits: {
                title: 'Nawyki',
                where: 'Nawyki — odhaczę nawyk, który rozpoznam po nazwie („wody" → Woda), a przy celu ilościowym dodam tyle, ile powiesz. Nowy nawyk dodam tylko, gdy wprost o to poprosisz.',
                ex1: 'Wypiłem 2 szklanki wody',
                ex2: 'Dziś bez słodyczy',
                ex3: 'Jak mi idzie z wodą?',
            },
            medications: {
                title: 'Leki',
                where: 'Leki — „wziąłem leki" odhaczy dawki, których pora właśnie minęła albo zaraz będzie (i dzisiejsze spóźnione), a „wziąłem apap" najbliższą dawkę tego leku. Lek spoza Leków zapiszę jako jednorazowe przyjęcie.',
                ex1: 'Wziąłem leki',
                ex2: 'Dziś nie biorę witaminy D',
                ex3: 'Czy wziąłem dziś leki?',
            },
            photos: {
                title: 'Zdjęcia',
                where: 'Aparat obok pola — do 10 zdjęć naraz (możesz też wkleić albo przeciągnąć). Paragon, lista, notatka, plakat albo talerz — asystent rozpozna i zapisze; długą listę na kilku zdjęciach złoży w jedną. Dopisz słowo, żeby wskazać miejsce. Gdy nie wie, zapyta.',
                ex1: 'Zdjęcie listy + „do zakupów"',
                ex2: 'Zdjęcie kartki + „zadania na jutro"',
                ex3: 'Zdjęcie plakatu koncertu',
            },
            questions: {
                title: 'Pytania o twoje dane',
                where: 'Odpowiedź z tego, co zapisane — z tego i poprzedniego tygodnia oraz planów na dwa tygodnie naprzód.',
                ex1: 'Ile wydałem w tym tygodniu?',
                ex2: 'Co mam jutro?',
                ex3: 'Kiedy ostatnio biegałem?',
                ex4: 'Co teraz?',
            },
            corrections: {
                title: 'Poprawki',
                where: 'Poprawia ostatnią zapisaną rzecz. Pod każdą wiadomością jest też „Cofnij".',
                ex1: 'Nie 100, tylko 120',
                ex2: 'To było wczoraj',
                ex3: 'Cofnij to',
            },
        },
    },
    // Objaśnienia sekcji i kroki przewodnika (te same teksty)
    help: {
        welcome: { title: 'Rozmowa z asystentem', text: 'Tu mówisz albo piszesz w ciągu dnia, co robisz, jesz, wydajesz i planujesz. Asystent od razu zapisuje to we właściwych modułach i krótko odpowiada.' },
        composer: { title: 'Pole wiadomości', text: 'Pisz zwyczajnie, kilka rzeczy naraz też. Enter wysyła, Shift+Enter to nowa linia.' },
        mic: { title: 'Mikrofon', text: 'Naciśnij, powiedz, wyślij. Gdy mówisz, asystent odpowiada też głosem (zmienisz to w Ustawienia → Aplikacja).' },
        receipt: { title: 'Zdjęcia', text: 'Do 10 naraz: paragon, lista zakupów albo zadań, notatka, plakat, talerz z jedzeniem. Asystent rozpozna, co na nich jest, i zapisze we właściwym miejscu (kilka zdjęć jednej listy to jedna lista) — dopisz słowo, jeśli chcesz inaczej. Gdy nie będzie pewien, zapyta. Paragon trafia do ostatniego wydatku (albo tego, o który pytał).' },
        records: { title: 'Co zapisano', text: 'Pod wiadomością widać, co z niej zapisano i gdzie. „Zobacz" otwiera moduł, „Cofnij" usuwa zapis. Przekreślone — cofnięte; z kreską — usunięte już w module.' },
        rightNow: { title: 'Teraz', text: 'Co w najbliższym czasie wymaga uwagi: dzisiejsze wydarzenia, zadanie w ciągu 3 godzin, spóźnione zadanie, posiłek do zjedzenia, płatność na dziś, termin projektu, zaległe zadania, a z Ludzi — urodziny i inne ważne daty w ciągu tygodnia oraz osoby, z którymi dawno nie było kontaktu, a ze Zwierząt i Sprzętów — obsługi na tydzień przed terminem (i po nim, dopóki nie zrobione), koniec gwarancji w ciągu miesiąca i urodziny zwierzaka, a z Leków — dawka od pół godziny przed jej porą (nieodhaczona — do końca dnia) i lek, którego zapas starczy na mniej niż tydzień. Najpilniejsze na górze. Kółko odhacza zadanie, „Zrobione" zapisuje obsługę, „Wzięte" odhacza dawkę, kliknięcie otwiera moduł. Możesz też zapytać „co teraz?".' },
        goingOn: { title: 'Trwa', text: 'Czynności, które trwają, z czasem od początku. „Zakończ" albo zwykłe „skończyłem" zapisuje ich koniec. Gdy coś trwa ponad 3 godziny, asystent sam zapyta.' },
        questions: { title: 'Do uzupełnienia', text: 'O co asystent dopytał, a odpowiedź jeszcze nie padła — np. paragon albo co było w koszyku. Odpowiedz zwykłą wiadomością albo zamknij pytanie krzyżykiem.' },
        days: { title: 'Dni rozmowy', text: 'Rozmowa jest jedna, ale oglądasz ją dniami. Strzałkami przejdziesz do wcześniejszych dni.' },
        summary: { title: 'Podsumuj dzień', text: 'Asystent zbierze dzień w kilka zdań. Poprawiasz i zapisujesz jako wpis dnia w Planerze.' },
        done: { title: 'Pomoc jest tutaj', text: 'Ściąga z przykładami, ten przewodnik i Pierwsze kroki — zawsze pod „Pomoc".' },
    },
    firstSteps: {
        expense: {
            title: 'Pierwszy wydatek',
            action: 'Powiedz wydatek',
            what: 'Powiedz, ile i gdzie wydajesz, np. „wydałem 100 zł w Biedronce".',
            why: 'Trafi do Portfela z kategorią — bez otwierania formularza.',
        },
        receipt: {
            title: 'Paragon do wydatku',
            action: 'Wyślij zdjęcie',
            what: 'Po wydatku zrób zdjęcie paragonu aparatem obok pola.',
            why: 'Asystent rozbije wydatek na produkty i kategorie, a zdjęcie zostanie przy transakcji.',
        },
        meal: {
            title: 'Posiłek',
            action: 'Powiedz, co jesz',
            what: 'Powiedz, co jesz albo co planujesz zjeść.',
            why: 'Jedzenie policzy kalorie i makro, a dzień w Planerze pokaże posiłek.',
        },
        activity: {
            title: 'Czynność od początku do końca',
            action: 'Zacznij czynność',
            what: 'Powiedz „idę pod prysznic", a potem „skończyłem".',
            why: 'Asystent policzy, ile to trwało, i wstawi to na oś dnia w Planerze.',
        },
        plan: {
            title: 'Plan',
            action: 'Powiedz plan',
            what: 'Powiedz, co cię czeka, np. „jutro o 18 dentysta" albo „muszę zadzwonić do mamy".',
            why: 'Z godziną będzie wydarzeniem, bez godziny — zadaniem w Planerze.',
        },
        question: {
            title: 'Pytanie o swoje dane',
            action: 'Zapytaj',
            what: 'Zapytaj np. „ile wydałem w tym tygodniu?" albo „co mam jutro?".',
            why: 'Nie musisz szukać po modułach — asystent policzy i odpowie.',
        },
        voice: {
            title: 'Powiedz to głosem',
            action: 'Włącz mikrofon',
            what: 'Naciśnij mikrofon i powiedz cokolwiek z tej listy.',
            why: 'W biegu najszybciej — asystent odpowie też głosem.',
        },
    },
    // Zapoznanie: asystent i użytkownik przedstawiają się sobie, potem — jeśli chce — cele
    introduction: {
        title: 'Poznajmy się',
        open: 'Zapoznanie',
        openHint: 'Imiona, głos i cele — jeszcze raz',
        hello: 'Hej! Tu Twój asystent. Mów albo pisz mi w ciągu dnia, co robisz, jesz, wydajesz i planujesz — zapiszę to w odpowiednie miejsca. Zanim zaczniemy, poznajmy się.',
        skip: 'Pomiń',
        skipAll: 'Pomiń wszystko',
        skipped: 'Pominięte',
        next: 'Dalej',
        back: 'Wstecz',
        save: 'Zapisz',
        start: 'Zaczynamy',
        stepOf: 'Krok {n} z {total}',
        phases: {
            hello: { label: 'Witaj', hint: 'Poznaj swojego asystenta', title: 'Cześć! Jestem Twoim asystentem.', lead: 'Mogę z Tobą rozmawiać, pomagać w planowaniu i zapisywać rzeczy w odpowiednie miejsca w Rountine.' },
            you: { label: 'Twoje imię', hint: 'Jak mam się do Ciebie zwracać?', title: 'A teraz Ty.', lead: 'Powiedz, jak mam się do Ciebie zwracać — będę używać imienia z umiarem.' },
            goals: { label: 'Twoje cele', hint: 'Co jest dla Ciebie ważne?', title: 'Co jest dla Ciebie ważne?', lead: 'Cele możemy ustalić teraz albo później — każdą sekcję możesz pominąć.' },
            areas: { label: 'Obszary życia', hint: 'Wybierz, od czego zaczynamy', title: 'Od czego zaczynamy?', lead: 'Wybrane obszary przypnę na pasku, żeby były pod ręką. Pozostałe moduły zostają w menu.' },
            end: { label: 'Gotowe', hint: 'Ruszamy do działania!', title: 'Gotowe!', lead: 'Wszystko zapisane. Do Zapoznania wrócisz w każdej chwili.' },
        },
        hints: {
            assistantName: 'Możesz wybrać jedną z propozycji albo napisać własną.',
            voice: 'Głos zmienisz później w Ustawieniach.',
            userName: 'Możesz też to pominąć — będę mówić bez imienia.',
            goalsPick: 'Każdą sekcję możesz pominąć w trakcie.',
            nutrition: 'Wyliczam ze wzoru Mifflina-St Jeora — wynik możesz poprawić.',
            areas: 'Przypięte zmienisz w Ustawieniach → Menu.',
        },
        assistantName: {
            ask: 'Jak mam się nazywać? Wymyśl mi imię — np. Ola albo Kuba.',
            placeholder: 'np. Ola',
            answered: '{name} — podoba mi się!',
            female: 'Ola',
            male: 'Kuba',
            beFemale: 'Możesz być {name}',
            beMale: 'Nazywaj się {name}',
            surpriseMe: 'Zaskocz mnie',
            own: 'Wpiszę samodzielnie',
            surprise: {
                female: 'Zosia, Lena, Iga, Hania, Maja, Nela',
                male: 'Max, Leo, Tymek, Franek, Olek, Staś',
            },
        },
        voice: {
            ask: 'Jakim głosem mam mówić? Kliknij, żeby posłuchać.',
        },
        userName: {
            ask: 'A jak Ty masz na imię? Jak mam się do Ciebie zwracać?',
            placeholder: 'np. Paweł',
            answered: 'Miło mi, {name}!',
        },
        gender: {
            ask: 'Jak mam do Ciebie pisać — w formie żeńskiej czy męskiej? Na przykład „zapisałaś” albo „zapisałeś”.',
            female: 'W żeńskiej',
            male: 'W męskiej',
        },
        goalsAsk: {
            ask: 'Chcesz od razu ustalić cele? Wagę docelową, cele żywieniowe i cel oszczędnościowy — to zajmie chwilę.',
            yes: 'Tak, ustalmy',
            no: 'Nie teraz',
        },
        areas: {
            ask: 'Którymi obszarami życia zajmiemy się na początek? Przypnę je na pasku — resztę znajdziesz w menu.',
            food: 'Jedzenie',
            health: 'Zdrowie i forma',
            money: 'Pieniądze',
            home: 'Dom i bliscy',
            work: 'Praca i pomysły',
        },
        goalsLater: 'Jasne. Cele ustawisz w każdej chwili:',
        later: {
            weight: 'w Formie, na zakładce Waga',
            nutrition: 'w Ustawieniach → Cele',
            savings: 'w Portfelu, w Planach',
        },
        goalsPick: {
            ask: 'Które cele ustalamy?',
        },
        goals: {
            weight: 'Waga docelowa',
            nutrition: 'Cele żywieniowe',
            savings: 'Cel oszczędnościowy',
        },
        weight: {
            ask: 'Ile teraz ważysz i do jakiej wagi zmierzasz?',
            now: 'Teraz',
            target: 'Docelowo',
            answer: 'cel {kg} kg',
        },
        nutrition: {
            ask: 'Wyliczę dzienne kalorie i makro. Potrzebuję kilku danych:',
            activity: 'Aktywność',
        },
        nutritionResult: {
            ask: 'Wychodzi {calories} kcal dziennie: białko {protein} g, węglowodany {carbs} g, tłuszcz {fat} g. Zapisać? Kalorie możesz poprawić.',
        },
        savingsExisting: {
            ask: 'Masz już cele oszczędnościowe: {list}. Dodać kolejny?',
            add: 'Dodaj kolejny',
        },
        savings: {
            ask: 'Na co odkładasz? Podaj nazwę, kwotę i termin.',
            name: 'Na co',
            namePlaceholder: 'np. Wakacje',
            amount: 'Kwota',
            deadline: 'Do kiedy',
            noDeadline: 'Bez terminu',
            monthly: 'Miesięcznie',
            account: 'Na koncie',
            initial: 'Już odłożone',
            newAccount: 'Założę w Portfelu konto „{name}” z tym, co już masz odłożone.',
        },
        end: 'Gotowe! Teraz mów albo pisz mi, co się dzieje — zajmę się resztą.',
        returnHint: 'Do Zapoznania wrócisz w każdej chwili: „Pomoc” w rozmowie albo Ustawienia → Profil.',
        again: 'Zapoznajmy się jeszcze raz',
        closedHint: 'Do Zapoznania wrócisz z „Pomoc” w rozmowie albo z Ustawień → Profil.',
    },
};
